module.exports = __webpack_public_path__ + "img/spensy.851bb6f8.jpg";